import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useInfiniteQuery } from '../useInfiniteQuery';
import { ReportGroupAsset, REPORT_GROUP_ASSETS_QUERY_KEY } from './useListReportGroupAssets';

import { DATA_GRID_LAZY_PAGE_SIZE } from '@/components/DataGrid/definitions';

const PAGE_SIZE = DATA_GRID_LAZY_PAGE_SIZE;

export const useInfiniteReportGroupAssets = ({
  reportId,
  groupId,
  enabled,
}: {
  reportId?: string;
  groupId?: string;
  enabled: boolean;
}) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const result = useInfiniteQuery({
    queryKey: parameters => [REPORT_GROUP_ASSETS_QUERY_KEY, { reportId, groupId, tenantId, ...parameters }],
    queryFunction: (parameters: { page?: number; perPage?: number }) =>
      api.reports.listReportGroupAssets({
        tenantId: tenantId ?? '',
        reportId: reportId ?? '',
        groupId: groupId ?? '',
        page: parameters.page ?? 1,
        perPage: parameters.perPage ?? PAGE_SIZE,
      }),
    dataKey: 'assets',
    options: {
      perPage: PAGE_SIZE,
      enabled: enabled && !!reportId && !!groupId && !!tenantId,
    },
  });

  const assets: ReportGroupAsset[] = (result.assets as ReportGroupAsset[]) ?? [];

  const isPlaceholderData = result.rawResult.isPlaceholderData;

  return {
    assets: isPlaceholderData ? [] : assets,
    total: isPlaceholderData ? 0 : result.total,
    isLoading: result.isLoading || isPlaceholderData,
    isFetchingNextPage: result.isFetchingNextPage,
    hasNextPage: result.hasNextPage,
    fetchNextPage: result.fetchNextPage,
    error: result.error,
  };
};
